import { api } from './configs/axiosConfig';

const endPoint = "/customer";

export const customersAPI = {
    getCustomers: async function (pCode, searchKey) {
        const reponse = await api.request({
            url: endPoint,
            method: 'GET',
            params: { pCode, searchKey }
        });

        return reponse.data;
    }
}